export const generateI18nResources = (languageKeys, generateResource) =>
  languageKeys.forEach(generateResource);
